<section class="experience-switcher" aria-label="Universes">
  <header class="experience-switcher__header">
    <h2 class="experience-switcher__title">
      {{ i18n + '.experiences.title' | translate }}
    </h2>
    <div class="experience-switcher__header-actions">
      <button
        type="button"
        class="experience-switcher__refresh-btn"
        [disabled]="isLoading()"
        [attr.aria-label]="i18n + '.experiences.refresh' | translate"
        (click)="refreshExperiences()"
      >
        <img
          src="/public/svgs/refresh.svg"
          alt=""
          width="14"
          height="14"
          [class.spin]="isLoading()"
        />
        {{ i18n + '.experiences.refresh' | translate }}
      </button>
      <button
        type="button"
        class="experience-switcher__add-btn"
        (click)="toggleCreateForm()"
      >
        {{ i18n + '.addUniverse.submit' | translate }}
      </button>
    </div>
  </header>

  @if (showCreateForm()) {
    <form class="experience-switcher__form" (ngSubmit)="submitCreateForm()">
      <label class="experience-switcher__field">
        <span class="experience-switcher__field-label">
          {{ i18n + '.experiences.nameLabel' | translate }}
        </span>
        <input
          class="experience-switcher__field-input"
          type="text"
          name="displayName"
          [ngModel]="newDisplayName()"
          (ngModelChange)="newDisplayName.set($event)"
          [placeholder]="i18n + '.experiences.namePlaceholder' | translate"
          maxlength="120"
          required
        />
      </label>
      <label class="experience-switcher__field">
        <span class="experience-switcher__field-label">
          {{ i18n + '.experiences.universeIdLabel' | translate }}
        </span>
        <input
          class="experience-switcher__field-input"
          type="text"
          name="universeId"
          inputmode="numeric"
          pattern="[0-9]*"
          [ngModel]="newUniverseId()"
          (ngModelChange)="newUniverseId.set($event)"
          [placeholder]="i18n + '.experiences.universeIdPlaceholder' | translate"
          required
        />
      </label>
      @if (createErrorKey(); as key) {
        <p class="experience-switcher__message experience-switcher__message--error">
          {{ i18n + '.experiences.errors.' + key | translate }}
        </p>
      }
      <div class="experience-switcher__form-actions">
        <button
          type="submit"
          class="experience-switcher__submit-btn"
          [disabled]="
            isAdding() ||
            !newDisplayName().trim() ||
            !newUniverseId().trim()
          "
        >
          {{
            isAdding()
              ? (i18n + '.experiences.saving' | translate)
              : (i18n + '.addUniverse.submit' | translate)
          }}
        </button>
        <button
          type="button"
          class="experience-switcher__cancel-btn"
          (click)="toggleCreateForm()"
        >
          {{ i18n + '.experiences.cancel' | translate }}
        </button>
      </div>
    </form>
  }

  @if (errorKey(); as key) {
    <p class="experience-switcher__message experience-switcher__message--error" role="alert">
      {{ i18n + '.experiences.errors.' + key | translate }}
    </p>
  }

  @if (isLoading()) {
    <p class="experience-switcher__message">
      {{ i18n + '.experiences.loading' | translate }}
    </p>
  } @else if (experiences().length === 0) {
    <p class="experience-switcher__message">
      {{ i18n + '.experiences.empty' | translate }}
    </p>
  } @else {
    <div class="experience-switcher__list" role="tablist">
      @for (experience of experiences(); track experience.registryId) {
        <button
          type="button"
          class="experience-switcher__card"
          role="tab"
          [attr.aria-selected]="experience.registryId === selectedRegistryId()"
          [class.experience-switcher__card--active]="
            experience.registryId === selectedRegistryId()
          "
          (click)="selectExperience(experience.registryId)"
        >
          <span class="experience-switcher__card-name">{{ experience.displayName }}</span>
          <span class="experience-switcher__card-meta">
            {{ i18n + '.experiences.universeId' | translate }}: {{ experience.communityId }}
          </span>
          <span
            class="experience-switcher__card-status"
            [attr.data-status]="experience.status"
          >
            {{ i18n + '.status.' + experience.status | translate }}
          </span>
          <span
            class="experience-switcher__card-bridge"
            [attr.data-bridge-status]="experience.bridgeStatus ?? 'never_seen'"
          >
            {{ bridgeStatusLabelKey(experience.bridgeStatus) | translate }}
          </span>
        </button>
      }
    </div>
  }
</section>
